import React, { useContext, useState, useRef, useEffect, ChangeEvent } from 'react';
import { CSSTransition } from 'react-transition-group';
import {IProps} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import Input from '@components/Input';
import Tooltip from '@components/Tooltip';
import {ITextAttributes} from 'routes/private/Editor/types';
import { Context } from "routes/private/Editor/Context";
import { findElementById, findCommonAttributeValue } from "@utils/editor";
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';

const FontSizeCommandOption:React.FC<IProps> = (props) => {
  const dsConfig = useSelector(selectors.dsConfig.getDSConfig);  
  let {editorStatus, data, onCommandChange} = useContext(Context);
  const [size, setSize]= useState<number>(dsConfig && dsConfig.editorConfig.defaultFontSize);
  const [showSizesList, setShowSizesList]= useState(false);
  const listRef = useRef(null);

  useEffect(() => {
    const size = findCommonAttributeValue(editorStatus.selectedElementsId, data, "fontSize", "Text", editorStatus.textSelectionInformation);
    setSize(!size?0:parseInt(size));
  }, [editorStatus.selectedElementsId.length, editorStatus.selectedElementsId[0], data, editorStatus.textSelectionInformation]);

  const handleClick = (e: any)=> {
    if(listRef && listRef.current){
        const ref: any = listRef.current
        if (!ref.contains(e.target)) setShowSizesList(false);
    }
  }

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [])

  const handleChangeInput = (e : any) => {
    const re = /^[0-9\b]+$/;
    if (re.test(e.target.value) && parseInt(e.target.value)<=dsConfig.editorConfig.fontSizeRange.max) setFontSize(true, parseInt(e.target.value));
    else if (e.target.value==="") setFontSize(true, undefined);
  }

  const handleClickButton = (increase: boolean) => {
    setFontSize(false, undefined, increase);
  }

  const setFontSize = (showList:boolean, newSize?: number, increase?: boolean) => { 
      setShowSizesList(showList);
      if(newSize) setSize(newSize);
      if (newSize!==0) onCommandChange("fontSize", { fontSize: newSize, increease: increase });    
  }

  return ( 
    <S.Root>
      <Tooltip tip={"Font Size"}>
        <S.Command ref={listRef}> 
          <S.Button left={true} onClick={()=> handleClickButton(false)}>-</S.Button>
          <Input 
            id={"size"}
            placeholder={""}
            value={ size === 0 ? "" : `${Math.round(size)}`}
            handleChange={(event:ChangeEvent<HTMLInputElement>) => handleChangeInput(event)}
            handleFocus={()=>setShowSizesList(true)}
            disabled={false}
            tipLabel={""}
            tipLabelColor={""}
            style={{
              display: "flex"
            }}
            inputStyle={{
              color: C.GENERIC_GRAY,
              border: `solid 0.5px ${C.GENERIC_GRAY}`,
              borderWidth: "1px 0 1px 0",
              backgroundColor: "transparent",
              height: "29px",
              borderRadius: "unset",
              width: "67px",
              textAlign: "center",
              padding: "0px"
            }}
          />
          <S.Button onClick={()=> handleClickButton(true)}>+</S.Button>
        </S.Command>
      </Tooltip>

      <CSSTransition in={showSizesList} timeout={200} classNames="list" unmountOnExit>
        <S.SizesList>
            {dsConfig?.editorConfig.fontSizes && 
            dsConfig.editorConfig.fontSizes.map((value: any, idx: number)=>
            <S.Option key={`op${idx}`} isSelected={size===value ? true : false} onClick={()=> setFontSize(false, value)}>
              {value}
            </S.Option>)}
        </S.SizesList>
      </CSSTransition>
    </S.Root>
  );


}

export default FontSizeCommandOption;